/**
 * mdast-util-from-markdown extension to build math nodes from micromark tokens.
 *
 * This extension handles the conversion of tokenized math delimiters into
 * proper MDAST nodes that can be used in the markdown AST.
 */
export function mathDelimitersFromMarkdown() {
    return {
        enter: {
            mathFlow: enterMathFlow,
            inlineMath: enterInlineMath
        },
        exit: {
            mathFlow: exitMathFlow,
            mathFlowFence: exitMathFlowFence,
            mathFlowValue: exitMathData,
            inlineMath: exitInlineMath,
            inlineMathData: exitMathData
        }
    };
    function enterMathFlow(token) {
        this.enter({
            type: "blockMath",
            value: "",
            data: {
                hName: "div",
                hProperties: { className: ["math", "math-display"] }
            }
        }, token);
    }
    function exitMathFlowFence() {
        // Exit if this is the closing fence
        if (this.data.mathFlowInside) {
            return;
        }
        this.buffer();
        this.data.mathFlowInside = true;
    }
    function exitMathFlow(token) {
        const data = this.resume().replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        const node = this.stack[this.stack.length - 1];
        this.exit(token);
        node.value = data;
        this.data.mathFlowInside = undefined;
    }
    function enterInlineMath(token) {
        this.enter({
            type: "inlineMath",
            value: "",
            data: {
                hName: "span",
                hProperties: { className: ["math", "math-inline"] }
            }
        }, token);
        this.buffer();
    }
    function exitInlineMath(token) {
        let data = this.resume();
        // Remove trailing backslash if present (from \) delimiter)
        if (data.endsWith("\\")) {
            data = data.slice(0, -1);
        }
        const node = this.stack[this.stack.length - 1];
        this.exit(token);
        node.value = data;
    }
    function exitMathData(token) {
        this.config.enter.data.call(this, token);
        this.config.exit.data.call(this, token);
    }
}
